import { z } from 'zod';
import { normalizeYaw } from '../angles.js';
import { DISPLAY_NAME_MAX, PASSWORD_MIN, USERNAME_MAX, USERNAME_MIN } from '../constants.js';
export const directionSchema = z.enum(['up', 'down', 'left', 'right']);
/** Payload von player:move — kontinuierliche Tile-Koordinaten. */
export const moveSchema = z.object({
    x: z.number().finite(),
    y: z.number().finite(),
    direction: directionSchema,
    /**
     * Blickwinkel der Ego-Ansicht. Wird auf 0..2*PI normalisiert, statt
     * ausserhalb liegende Werte abzulehnen — ein Rundungsfehler des Clients
     * darf nicht das ganze Bewegungspaket verwerfen.
     */
    yaw: z.number().finite().transform(normalizeYaw).optional(),
    seq: z.number().int().nonnegative(),
});
export const loginSchema = z.object({
    username: z.string().min(USERNAME_MIN).max(USERNAME_MAX),
    password: z.string().min(1).max(256),
});
/**
 * Grunddaten eines neuen Kontos. Rollen kommen nicht hierher: sie haengen
 * an der Umgebung (umgebungSchema) bzw. am Superadmin-Bit.
 */
export const createUserSchema = z.object({
    username: z
        .string()
        .min(USERNAME_MIN)
        .max(USERNAME_MAX)
        .regex(/^[a-zA-Z0-9_.-]+$/, 'Nur Buchstaben, Zahlen, _ . -'),
    displayName: z.string().trim().min(1).max(DISPLAY_NAME_MAX),
    password: z.string().min(PASSWORD_MIN).max(256),
});
//# sourceMappingURL=playerSchema.js.map